import { useInteractAway } from '../../../hooks/useInteractAway';
export function useOverlay({
  onClose,
  useKeyboardDissmiss = true
}, ref) {
  const {
    onMouseDownCapture,
    onTouchStartCapture
  } = useInteractAway(ref, onClose);
  function onKeyDown(evt) {
    if (evt.key === 'Escape' && useKeyboardDissmiss) {
      evt.preventDefault();
      onClose?.();
    }
  }
  return {
    overlayProps: {
      onKeyDown,
      onMouseDownCapture,
      onTouchStartCapture
    }
  };
}